const PILL_BY_STATUS = {
  ACCEPTED: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  VENDOR_ACCEPTED: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  BUYER_ACCEPTED_COUNTER: 'bg-emerald-50 text-emerald-700 border-emerald-100',

  REJECTED: 'bg-red-50 text-red-700 border-red-100',
  VENDOR_DECLINED: 'bg-red-50 text-red-700 border-red-100',

  VENDOR_COUNTERED: 'bg-amber-50 text-amber-700 border-amber-100',
  BUYER_COUNTERED: 'bg-amber-50 text-amber-700 border-amber-100',
  COUNTER_OFFER: 'bg-amber-50 text-amber-700 border-amber-100',

  WITHDRAWN: 'bg-gray-50 text-gray-500 border-gray-200',
  BUYER_WITHDRAWN: 'bg-gray-50 text-gray-500 border-gray-200',
  EXPIRED: 'bg-gray-50 text-gray-500 border-gray-200',

  SUBMITTED: 'bg-blue-50 text-blue-700 border-blue-100',
  UNDER_REVIEW: 'bg-blue-50 text-blue-700 border-blue-100',
  PENDING_VENDOR_REVIEW: 'bg-blue-50 text-blue-700 border-blue-100',
};

export const offerStatusPillClasses = (status) =>
  PILL_BY_STATUS[status] || 'bg-blue-50 text-blue-700 border-blue-100';

// Agent-facing display labels. The model's generic terminal decline is
// `REJECTED` ("Rejected"), but agents declining a buyer's offer expect to see
// it worded as "Declined" on the property Offers tab. Overridden here (CRM
// display only — buyer emails are unaffected and aren't sent on a status edit).
const LABEL_BY_STATUS = {
  REJECTED: 'Declined',
};

export const offerStatusLabel = (status, fallback) =>
  LABEL_BY_STATUS[status] || fallback || status;
